import { render, staticRenderFns } from "./resume-language-view.vue?vue&type=template&id=2cd41e40&scoped=true&"
import script from "./resume-language-view.vue?vue&type=script&lang=js&"
export * from "./resume-language-view.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cd41e40",
  null
  
)

export default component.exports